import * as React from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import CardSys from "../../cardSys";
import CardSysPdf from "../../cardSysPdf2";

export default function CardBasicPdf2({ children, ...props }) {
  return (
    <Box {...props}>
      <CardSysPdf sx={{height: "100%"}}>
        <CardContent sx={{padding: "0px", height: "100%"}} >{children}</CardContent>
      </CardSysPdf>
    </Box>
  );
}
